import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CarModelQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  nameIcontains?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CarModelQuery = { __typename?: 'Query', carModel?: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, carsubmodelSet?: { __typename?: 'CarSubModelNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CarSubModelNodeEdge', node?: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null } | null } | null> } | null } | null };


export const CarModelDocument = gql`
    query CarModel($id: ID!, $offset: Int, $before: String, $after: String, $first: Int, $last: Int, $nameIcontains: String) {
  carModel(id: $id) {
    id
    name
    localName
    carsubmodelSet(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      nameIcontains: $nameIcontains
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        node {
          id
          name
          localName
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCarModelQuery__
 *
 * To run a query within a React component, call `useCarModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarModelQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      nameIcontains: // value for 'nameIcontains'
 *   },
 * });
 */
export function useCarModelQuery(baseOptions: Apollo.QueryHookOptions<CarModelQuery, CarModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarModelQuery, CarModelQueryVariables>(CarModelDocument, options);
      }
export function useCarModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarModelQuery, CarModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarModelQuery, CarModelQueryVariables>(CarModelDocument, options);
        }
export type CarModelQueryHookResult = ReturnType<typeof useCarModelQuery>;
export type CarModelLazyQueryHookResult = ReturnType<typeof useCarModelLazyQuery>;
export type CarModelQueryResult = Apollo.QueryResult<CarModelQuery, CarModelQueryVariables>;